const state = () => ({
  requestResetPassword: {
    apiRunning: false,
    email: undefined,
  },
});
export default state;
